import ArchivedJobs from "../../components/candidate/archivedJobs";

const ArchivedCandidatePage = () => {
  return <ArchivedJobs />;
};

export default ArchivedCandidatePage;
